import { LitElement } from '~/lib/bn-lit-element';
import { css } from '../../utility/lit-entity';
import { DeviceMonitoringChartLayerLineMixin } from './device-monitoring-chart-layer-line-mixin';

export const colour = css`var(--orange-20)`;

export const hasWarning = () => false;
export const hasAlert = () => false;

class DeviceMonitoringChartLayerSensorTemperature extends DeviceMonitoringChartLayerLineMixin(LitElement) {
  constructor() {
    super();
    this.dataKey = 'sensorTemperature';
    this.maxValue = 65;
    this.minValue = -30;
  }

  static get styles() {
    return [...super.styles, css`
      :host {
        --good-stroke: var(--orange-20);
        --warning-stroke: ${colour};
        --alert-stroke: var(--red-20);
      }
    `];
  }
}

window.customElements.define('device-monitoring-chart-layer-sensor-temperature', DeviceMonitoringChartLayerSensorTemperature);
